import React from 'react';
import DailyProverb from '../../components/DailyProverb/DailyProverb';
import SearchBar from '../../components/SearchBar/SearchBar';
import ProverbGrid from '../../components/ProverbGrid/ProverbGrid';
import { useSearch } from '../../hooks/useSearch';
import { useDailyProverb } from '../../hooks/useDailyProverb';
import { useScrollPosition } from '../../hooks/useScrollPosition';
import proverbs from '../../proverbs.json';

interface Proverb {
  marathi: string;
  literal: string;
  idiomatic: string;
}

const Home: React.FC = () => {
  const { setQuery, results, resultsCount, totalCount, isSearching } = useSearch(
    proverbs as Proverb[]
  );
  const dailyProverb = useDailyProverb(proverbs as Proverb[]);
  useScrollPosition();

  return (
    <>
      {dailyProverb && <DailyProverb proverb={dailyProverb} />}
      <SearchBar onSearch={setQuery} />
      <main id="main-content" className="main-content">
        {isSearching && (
          <div
            className="search-results-info"
            role="status"
            aria-live="polite"
            aria-atomic="true"
          >
            Showing {resultsCount} of {totalCount} proverbs
          </div>
        )}
        <ProverbGrid proverbs={results} />
      </main>
    </>
  );
};

export default Home;
